import React, { useState, useEffect } from 'react';

import axios from 'axios';

const DEPARTEMENTS = ['01 – Ain','02 – Aisne','03 – Allier','04 – Alpes-de-Haute-Provence','05 – Hautes-Alpes','06 – Alpes-Maritimes','07 – Ardèche','08 – Ardennes','09 – Ariège','10 – Aube','11 – Aude','12 – Aveyron','13 – Bouches-du-Rhône','14 – Calvados','15 – Cantal','16 – Charente','17 – Charente-Maritime','18 – Cher','19 – Corrèze','21 – Côte-d’Or','22 – Côtes-d’Armor','23 – Creuse','24 – Dordogne','25 – Doubs','26 – Drôme','27 – Eure','28 – Eure-et-Loir','29 – Finistère','30 – Gard','31 – Haute-Garonne','32 – Gers','33 – Gironde','34 – Hérault','35 – Ille-et-Vilaine','36 – Indre','37 – Indre-et-Loire','38 – Isère','39 – Jura','40 – Landes','41 – Loir-et-Cher','42 – Loire','43 – Haute-Loire','44 – Loire-Atlantique','45 – Loiret','46 – Lot','47 – Lot-et-Garonne','48 – Lozère','49 – Maine-et-Loire','50 – Manche','51 – Marne','52 – Haute-Marne','53 – Mayenne','54 – Meurthe-et-Moselle','55 – Meuse','56 – Morbihan','57 – Moselle','58 – Nièvre','59 – Nord','60 – Oise','61 – Orne','62 – Pas-de-Calais','63 – Puy-de-Dôme','64 – Pyrénées-Atlantiques','65 – Hautes-Pyrénées','66 – Pyrénées-Orientales','67 – Bas-Rhin','68 – Haut-Rhin','69 – Rhône','70 – Haute-Saône','71 – Saône-et-Loire','72 – Sarthe','73 – Savoie','74 – Haute-Savoie','75 – Paris','76 – Seine-Maritime','77 – Seine-et-Marne','78 – Yvelines','79 – Deux-Sèvres','80 – Somme','81 – Tarn','82 – Tarn-et-Garonne','83 – Var','84 – Vaucluse','85 – Vendée','86 – Vienne','87 – Haute-Vienne','88 – Vosges','89 – Yonne','90 – Territoire de Belfort','91 – Essonne','92 – Hauts-de-Seine','93 – Seine-Saint-Denis','94 – Val-de-Marne','95 – Val-d’Oise','971 – Guadeloupe','972 – Martinique','973 – Guyane','974 – La Réunion','976 – Mayotte'];
const API = 'https://app.recensement-enfantsnonproteges.fr';

const TYPES_VIOLENCE = ['Viols','Agressions sexuelles','Violences physiques','Contrôle coercitif','Violence institutionnelle'];
const ETATS_PLAINTE = ['IP (Information préoccupante)','Signalement','Plainte police','Plainte avec CPC','CSS (Classement sans suite)','Non-lieu','Acquittement','Relaxe','Condamné'];
const RAISONS = ['Aliénation parentale','Surprotection','Conflit parental','Conflit de loyauté','Autre'];

export default function Admin({ token, onLogout }) {
  const [fiches, setFiches] = useState([]);
  const [attente, setAttente] = useState([]);
  const [demandes, setDemandes] = useState({presse:[],elus:[]});
  const [modifications, setModifications] = useState([]);
  const [onglet, setOnglet] = useState('attente');
  const [search, setSearch] = useState('');
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saveMsg, setSaveMsg] = useState('');
  const headers = { Authorization: 'Bearer ' + token };

  const load = () => {
    axios.get(API+'/api/admin/fiches', { headers }).then(r => setFiches(r.data)).catch(() => {});
    axios.get(API+'/api/admin/fiches/attente', { headers }).then(r => setAttente(r.data)).catch(() => {});
    axios.get(API+'/api/admin/demandes', { headers }).then(r => setDemandes(r.data)).catch(() => {});
    axios.get(API+'/api/admin/demandes/modifications', { headers }).then(r => setModifications(r.data)).catch(() => {});
  };

  useEffect(() => { load(); }, []);

  const accepter = async (id) => { await axios.patch(API+'/api/admin/fiches/'+id+'/accepter', {}, { headers }); load(); };
  const rejeter = async (id) => { await axios.patch(API+'/api/admin/fiches/'+id+'/rejeter', {}, { headers }); load(); };
  const toggleAlerte = async (id, current) => { await axios.patch(API+'/api/admin/fiches/'+id+'/alerte', { alerte_urgence: !current }, { headers }); load(); };
  const toggleVisible = async (id, current) => { await axios.patch(API+'/api/admin/fiches/'+id+'/visible', { visible: !current }, { headers }); load(); };

  const startEdit = (f) => {
    setEditing(f.id);
    setEditForm({
      pp_prenom: f.pp_prenom||'', pp_nom: f.pp_nom||'', pp_tel: f.pp_tel||'', pp_email: f.pp_email||'',
      tribunal: f.tribunal||'', departement: f.departement||'',
      type_violences: f.type_violences||[],
      garde_agresseur: f.garde_agresseur||'', garde_pp: f.garde_pp||'',
      etat_plainte: f.etat_plainte||'', raison_invoquee: f.raison_invoquee||'',
      temoignage: f.temoignage||'',
      nb_preuves: f.nb_preuves||'', nb_magistrats: f.nb_magistrats||'', nb_jugements: f.nb_jugements||'',
      nb_dysfonctionnements: f.nb_dysfonctionnements||'', nb_dossier_perdu: f.nb_dossier_perdu||'',
      nb_enfant_a_parle: f.nb_enfant_a_parle||'', nb_agents_ase: f.nb_agents_ase||'',
      cout_financier: f.cout_financier||'', cout_medical: f.cout_medical||'', cout_professionnel: f.cout_professionnel||'',
      nb_plaintes_pp: f.nb_plaintes_pp||'', nb_condamnations_pp: f.nb_condamnations_pp||'',
      remarque_procedure: f.remarque_procedure||'',
      alerte_urgence: f.alerte_urgence||false, visible: f.visible||false,
    });
    setSaveMsg('');
  };

  const saveEdit = async () => {
    try {
      await axios.patch(API+'/api/admin/fiches/'+editing+'/edit', editForm, { headers });
      setSaveMsg('✓ Sauvegardé');
      load();
      setTimeout(() => setSaveMsg(''), 3000);
    } catch(e) { setSaveMsg('Erreur'); }
  };

  const toggleV = (v) => setEditForm(f => ({...f, type_violences: f.type_violences.includes(v) ? f.type_violences.filter(x=>x!==v) : [...f.type_violences, v]}));

  const filtered = fiches.filter(f => {
    if (search) { const s = search.toLowerCase(); return (f.pp_prenom||'').toLowerCase().includes(s)||(f.pp_nom||'').toLowerCase().includes(s); }
    return true;
  });

  const Field = ({ label, children }) => (
    <div style={{marginBottom:'12px'}}>
      <label style={{fontSize:'11px',fontWeight:'600',color:'#555',display:'block',marginBottom:'4px'}}>{label}</label>
      {children}
    </div>
  );

  const inp = {width:'100%',fontSize:'13px',border:'1px solid #dde3f0',borderRadius:'6px',padding:'7px 10px',fontFamily:'inherit'};

  return (
    <div className="admin-page">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
        <h2 style={{margin:0}}>Backoffice</h2>
        {onLogout && <button onClick={onLogout} style={{background:'transparent',border:'1px solid #dde3f0',borderRadius:'6px',padding:'6px 14px',fontSize:'12px',cursor:'pointer'}}>Déconnexion</button>}
      </div>

      <div style={{display:'flex',gap:'10px',marginBottom:'20px',flexWrap:'wrap',alignItems:'center'}}>
        {[
          ['attente', `En attente (${attente.length})`],
          ['publiees', `Publiées (${fiches.filter(f=>f.statut==='publiee').length})`],
          ['toutes', `Toutes (${fiches.length})`],
          ['demandes', `Demandes (${(demandes.presse||[]).length+(demandes.elus||[]).length})`],
          ['modifications', `Modifications (${modifications.length})`],
        ].map(([v,l]) => (
          <button key={v} className={`chip${onglet===v?' on':''}`} onClick={() => setOnglet(v)}>{l}</button>
        ))}
        <div style={{marginLeft:'auto',display:'flex',gap:'8px'}}>
          <a href={API+'/api/admin/export'} className="btn-outline" style={{fontSize:'12px',padding:'6px 14px',textDecoration:'none'}}>Export CSV fiches</a>
          <a href={API+'/api/admin/newsletter'} className="btn-outline" style={{fontSize:'12px',padding:'6px 14px',textDecoration:'none'}}>Export emails newsletter</a>
        </div>
      </div>

      {/* PANNEAU D'ÉDITION */}
      {editing && (
        <div style={{background:'#fff',border:'2px solid #1a7fd4',borderRadius:'12px',padding:'24px',marginBottom:'20px'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
            <div style={{fontSize:'15px',fontWeight:'700',color:'#0a1f44'}}>Modifier la fiche #{editing}</div>
            <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
              {saveMsg && <span style={{fontSize:'12px',color:saveMsg.includes('✓')?'#16a34a':'#dc2626'}}>{saveMsg}</span>}
              <button className="btn-blue" style={{fontSize:'12px',padding:'7px 16px'}} onClick={saveEdit}>Sauvegarder</button>
              <button className="btn-prev" style={{fontSize:'12px',padding:'7px 16px'}} onClick={() => setEditing(null)}>Fermer</button>
            </div>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'16px',marginBottom:'16px'}}>
            <Field label="Prénom"><input style={inp} value={editForm.pp_prenom} onChange={e=>setEditForm(f=>({...f,pp_prenom:e.target.value}))} /></Field>
            <Field label="Nom"><input style={inp} value={editForm.pp_nom} onChange={e=>setEditForm(f=>({...f,pp_nom:e.target.value}))} /></Field>
            <Field label="Téléphone"><input style={inp} value={editForm.pp_tel} onChange={e=>setEditForm(f=>({...f,pp_tel:e.target.value}))} /></Field>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'16px',marginBottom:'16px'}}>
            <Field label="Email"><input style={inp} value={editForm.pp_email} onChange={e=>setEditForm(f=>({...f,pp_email:e.target.value}))} /></Field>
            <Field label="Tribunal (ville)"><input style={inp} value={editForm.tribunal} onChange={e=>setEditForm(f=>({...f,tribunal:e.target.value}))} /></Field>
            <Field label="Département">
              <select style={inp} value={editForm.departement} onChange={e=>setEditForm(f=>({...f,departement:e.target.value}))}>
                <option value="">Sélectionner…</option>
                {DEPARTEMENTS.map(d => <option key={d} value={d}>{d}</option>)}
              </select>
            </Field>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',marginBottom:'16px'}}>
            <Field label="État de la plainte">
              <select style={inp} value={editForm.etat_plainte} onChange={e=>setEditForm(f=>({...f,etat_plainte:e.target.value}))}>
                {ETATS_PLAINTE.map(o=><option key={o}>{o}</option>)}
              </select>
            </Field>
            <Field label="Raison invoquée">
              <select style={inp} value={editForm.raison_invoquee} onChange={e=>setEditForm(f=>({...f,raison_invoquee:e.target.value}))}>
                {RAISONS.map(o=><option key={o}>{o}</option>)}
              </select>
            </Field>
          </div>

          <Field label="Types de violences">
            <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
              {TYPES_VIOLENCE.map(v=>(
                <label key={v} style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'13px',cursor:'pointer'}}>
                  <input type="checkbox" checked={(editForm.type_violences||[]).includes(v)} onChange={()=>toggleV(v)} style={{accentColor:'#1a7fd4'}} />{v}
                </label>
              ))}
            </div>
          </Field>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',margin:'16px 0'}}>
            <Field label="Garde agresseur"><input style={inp} value={editForm.garde_agresseur} onChange={e=>setEditForm(f=>({...f,garde_agresseur:e.target.value}))} /></Field>
            <Field label="Garde parent protecteur"><input style={inp} value={editForm.garde_pp} onChange={e=>setEditForm(f=>({...f,garde_pp:e.target.value}))} /></Field>
          </div>

          <Field label="Témoignage">
            <textarea style={{...inp,height:'80px',resize:'vertical'}} value={editForm.temoignage} onChange={e=>setEditForm(f=>({...f,temoignage:e.target.value}))} />
          </Field>

          <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:'12px',marginTop:'16px'}}>
            <Field label="Preuves"><input type="number" style={inp} value={editForm.nb_preuves} onChange={e=>setEditForm(f=>({...f,nb_preuves:e.target.value}))} /></Field>
            <Field label="Magistrats"><input type="number" style={inp} value={editForm.nb_magistrats} onChange={e=>setEditForm(f=>({...f,nb_magistrats:e.target.value}))} /></Field>
            <Field label="Jugements"><input type="number" style={inp} value={editForm.nb_jugements} onChange={e=>setEditForm(f=>({...f,nb_jugements:e.target.value}))} /></Field>
            <Field label="Dysfonct."><input type="number" style={inp} value={editForm.nb_dysfonctionnements} onChange={e=>setEditForm(f=>({...f,nb_dysfonctionnements:e.target.value}))} /></Field>
            <Field label="Enfant a parlé"><input type="number" style={inp} value={editForm.nb_enfant_a_parle} onChange={e=>setEditForm(f=>({...f,nb_enfant_a_parle:e.target.value}))} /></Field>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'12px',marginTop:'12px'}}>
            <Field label="Coût juridique (€)"><input type="number" style={inp} value={editForm.cout_financier} onChange={e=>setEditForm(f=>({...f,cout_financier:e.target.value}))} /></Field>
            <Field label="Coût médical (€)"><input type="number" style={inp} value={editForm.cout_medical} onChange={e=>setEditForm(f=>({...f,cout_medical:e.target.value}))} /></Field>
            <Field label="Coût professionnel (€)"><input type="number" style={inp} value={editForm.cout_professionnel} onChange={e=>setEditForm(f=>({...f,cout_professionnel:e.target.value}))} /></Field>
            <Field label="Agents ASE"><input type="number" style={inp} value={editForm.nb_agents_ase} onChange={e=>setEditForm(f=>({...f,nb_agents_ase:e.target.value}))} /></Field>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginTop:'12px'}}>
            <Field label="Plaintes contre PP"><input type="number" style={inp} value={editForm.nb_plaintes_pp} onChange={e=>setEditForm(f=>({...f,nb_plaintes_pp:e.target.value}))} /></Field>
            <Field label="Condamnations PP"><input type="number" style={inp} value={editForm.nb_condamnations_pp} onChange={e=>setEditForm(f=>({...f,nb_condamnations_pp:e.target.value}))} /></Field>
          </div>

          <Field label="Remarques"><textarea style={{...inp,height:'60px',resize:'vertical',marginTop:'12px'}} value={editForm.remarque_procedure} onChange={e=>setEditForm(f=>({...f,remarque_procedure:e.target.value}))} /></Field>
        </div>
      )}

      {/* EN ATTENTE */}
      {onglet==='attente' && (
        <div>
          {attente.length===0 && <div style={{padding:'40px',textAlign:'center',color:'#888'}}>Aucune fiche en attente.</div>}
          {attente.map(f => (
            <div key={f.id} className="fiche" style={{marginBottom:'12px'}}>
              <div className="fiche-h">
                <div className="av">{(f.pp_prenom||'A')[0]}</div>
                <div className="fiche-info">
                  <div className="fn">{f.pp_prenom} {f.pp_nom}</div>
                  <div className="fm">{f.pp_tel} · {f.pp_email}</div>
                  <div className="fm">{f.tribunal} · {f.departement} · {new Date(f.created_at).toLocaleDateString('fr-FR')}</div>
                </div>
              </div>
              <div className="fiche-b">
                <div className="kv-grid">
                  {f.garde_agresseur&&<div className="kv"><span className="k">Garde agresseur</span><span className="v red">{f.garde_agresseur}</span></div>}
                  {f.etat_plainte&&<div className="kv"><span className="k">Plainte</span><span className="v">{f.etat_plainte}</span></div>}
                  {f.cout_financier&&<div className="kv"><span className="k">Coût juridique</span><span className="v">{Number(f.cout_financier).toLocaleString('fr-FR')} €</span></div>}
                </div>
                {f.temoignage&&<p className="temo">{f.temoignage}</p>}
              </div>
              <div className="fiche-f">
                <button className="btn-blue" style={{fontSize:'12px',padding:'6px 14px'}} onClick={() => accepter(f.id)}>Accepter et publier</button>
                <button style={{fontSize:'12px',padding:'6px 14px',background:'#fff',color:'#e24b4a',border:'1px solid #fca5a5',borderRadius:'7px',cursor:'pointer'}} onClick={() => rejeter(f.id)}>Rejeter</button>
                <button className="btn-prev" style={{fontSize:'12px',padding:'6px 14px'}} onClick={() => startEdit(f)}>✏ Modifier</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* PUBLIÉES / TOUTES */}
      {(onglet==='publiees'||onglet==='toutes') && (
        <div>
          <div className="admin-filters">
            <input type="text" placeholder="Rechercher…" value={search} onChange={e => setSearch(e.target.value)} style={{width:'300px'}} />
          </div>
          <table className="admin-table">
            <thead><tr><th>Parent protecteur</th><th>Contact</th><th>Juridiction</th><th>Violences</th><th>Statut</th><th>Date</th><th>Actions</th></tr></thead>
            <tbody>
              {filtered.filter(f => onglet==='toutes'||f.statut==='publiee').map(f => (
                <tr key={f.id} className={f.alerte_urgence?'urg':''}>
                  <td><strong>{f.pp_prenom} {f.pp_nom}</strong></td>
                  <td style={{fontSize:'11px'}}>{f.pp_tel&&<div>{f.pp_tel}</div>}{f.pp_email&&<div>{f.pp_email}</div>}</td>
                  <td style={{fontSize:'11px'}}>{f.tribunal}<br/>{f.departement}</td>
                  <td style={{fontSize:'11px'}}>{(f.type_violences||[]).join(', ')}</td>
                  <td style={{fontSize:'11px',color:f.statut==='publiee'?'#16a34a':f.statut==='rejetee'?'#dc2626':'#b45309'}}>{f.statut}</td>
                  <td style={{fontSize:'11px'}}>{new Date(f.created_at).toLocaleDateString('fr-FR')}</td>
                  <td>
                    <button className={`toggle-btn${f.alerte_urgence?' on':''}`} onClick={() => toggleAlerte(f.id, f.alerte_urgence)}>⚠ Urgence</button>
                    <button className="toggle-btn" onClick={() => toggleVisible(f.id, f.visible)}>{f.visible?'Masquer':'Afficher'}</button>
                    <button className="toggle-btn" onClick={() => startEdit(f)}>✏ Modifier</button>
                    {f.pp_cni_filename && <a href={API+'/api/admin/cni/'+f.pp_cni_filename} target="_blank" rel="noreferrer" className="toggle-btn">📎 CNI</a>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* DEMANDES */}
      {onglet==='demandes' && (
        <div>
          <div style={{fontSize:'14px',fontWeight:'600',marginBottom:'12px'}}>Journalistes ({(demandes.presse||[]).length})</div>
          {(demandes.presse||[]).map(d => (
            <div key={d.id} className="fiche" style={{marginBottom:'8px'}}>
              <div className="fiche-h">
                <div className="av">J</div>
                <div className="fiche-info">
                  <div className="fn">{d.redaction}</div>
                  <div className="fm">{d.email} · {new Date(d.created_at).toLocaleDateString('fr-FR')}</div>
                </div>
                <button className="toggle-btn" onClick={() => axios.patch(API+'/api/admin/demandes/presse/'+d.id,{},{headers}).then(load)}>Traité</button>
              </div>
            </div>
          ))}
          <div style={{fontSize:'14px',fontWeight:'600',margin:'16px 0 12px'}}>Élu·es ({(demandes.elus||[]).length})</div>
          {(demandes.elus||[]).map(d => (
            <div key={d.id} className="fiche" style={{marginBottom:'8px'}}>
              <div className="fiche-h">
                <div className="av">E</div>
                <div className="fiche-info">
                  <div className="fn">{d.nom}</div>
                  <div className="fm">{d.circonscription} · {new Date(d.created_at).toLocaleDateString('fr-FR')}</div>
                </div>
                <button className="toggle-btn" onClick={() => axios.patch(API+'/api/admin/demandes/elus/'+d.id,{},{headers}).then(load)}>Traité</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODIFICATIONS */}
      {onglet==='modifications' && (
        <div>
          {modifications.length===0 && <div style={{padding:'40px',textAlign:'center',color:'#888'}}>Aucune demande.</div>}
          {modifications.map(m => (
            <div key={m.id} className="fiche" style={{marginBottom:'12px'}}>
              <div className="fiche-h">
                <div className="av">M</div>
                <div className="fiche-info">
                  <div className="fn">Fiche #{m.fiche_id}</div>
                  <div className="fm">{m.pp_email} · {new Date(m.created_at).toLocaleDateString('fr-FR')}</div>
                </div>
              </div>
              <div className="fiche-b">
                <div style={{fontSize:'11px',color:'#aaa',marginBottom:'4px'}}>Témoignage actuel :</div>
                <p className="temo" style={{marginBottom:'10px'}}>{m.temoignage_actuel}</p>
                <div style={{fontSize:'11px',color:'#aaa',marginBottom:'4px'}}>Nouveau :</div>
                <p className="temo" style={{background:'#f0fdf4',borderColor:'#86efac'}}>{m.nouveau_temoignage}</p>
              </div>
              <div className="fiche-f">
                <button className="btn-blue" style={{fontSize:'12px',padding:'6px 14px'}} onClick={() => axios.patch(API+'/api/admin/demandes/modifications/'+m.id+'/accepter',{},{headers}).then(load)}>Accepter</button>
                <button style={{fontSize:'12px',padding:'6px 14px',background:'#fff',color:'#e24b4a',border:'1px solid #fca5a5',borderRadius:'7px',cursor:'pointer'}} onClick={() => axios.patch(API+'/api/admin/demandes/modifications/'+m.id+'/rejeter',{},{headers}).then(load)}>Rejeter</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
